export const sector = {
  name_one: "sector",
  name_other: "sectors",
  add: {
    label: "Add sector",
  },
  delete: {
    label: "Delete sector",
  },
  form: {
    associateLocationWith: "Associate this sector with",
    edit: {
      label: "Edit sector",
    },
    informations: "Sector information",
  },
};
